import { DONOR_ID, DONOR_ID_DETAIL, SETISRELOAD, setIsReload,  } from '../../actions/checkin'


export const ReloadDonorDataReducer = ( prevState = {
    isReload: false
}, action) => {
    switch (action.type) {
        case SETISRELOAD:
            let newState = { ...prevState }
            newState.isReload = !newState.isReload
            return newState
        default:
            return prevState
    }
}


const initState = {
  donorId: null,
  donorDetail: null,
}
export const donorIdStateReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case DONOR_ID:
        return { ...state, donorId: action.donorId }
    case DONOR_ID_DETAIL:
        return { ...state, donorDetail: action.donorDetail }
    default:
      return { ...state, ...action }
  }
}